import React, { useState, useEffect } from "react";
import UpperLayerTabLayout from "../../../Components/DetailsPageUpperLayer/UpperLayerTabLayout";
import { formatValue } from "../../../utils/currencyUtils";

const InboundOrderHeader = ({ hProps }) => {
  const [orderDetails, setOrderDetails] = useState({});
  const [paymentDetails, setPaymentDetails] = useState({});
  const isStockTransfer = hProps?.orderType === "STOCK_TRANSFER_PO";

  const fieldLabels = {
    erpOrderType: "ERP Order Type",
    orderType: "Order Type",
    lob: "LOB",
    lmd: "LMD",
  };

  useEffect(() => {
    // Keys to always show under "Order"
    const orderKeys = [
      "orderNo",
      "customer",
      "supplier",
      "supplierName",
      "createdBy",
      "shipTo",
      "shipToDescription",
      "lob",
      "incoTerms",
      "erpOrderType",
      "processType",
      "orderType",
      "lmd"
    ];
    // Keys to always show under "Payment"
    const paymentKeys = [
      "paymentTerms",
      !isStockTransfer && "soldTo",
      "creationDate",
      "headerState",
      "amount",
      "currency",
      //"monetaryImpact"
    ].filter(Boolean); // Remove falsey values

    // Helper to seed object with default values
    const seedWithDefaults = (src, keys) =>
      keys.reduce((acc, k) => {
        acc[k] = src?.[k] ?? null;    // null
        return acc;
      }, {});

    let orderDetails = seedWithDefaults(hProps || {}, orderKeys);
    let paymentDetails = seedWithDefaults(hProps || {}, paymentKeys);

    paymentDetails = {
      ...paymentDetails,
      amount: formatValue(hProps.amount),
    };
    setOrderDetails(orderDetails);
    setPaymentDetails(paymentDetails);
  }, [hProps, isStockTransfer]);

  return (
    <UpperLayerTabLayout
      firstHeading="Order"
      secondHeading="Payment"
      firstBoxData={orderDetails}
      secondBoxData={paymentDetails}
      title="Purchase Orders Detail"
      showThirdTab={false}
      showTrackAndTrace={false}
      fieldLabels={fieldLabels}
    />
  );
};

export default InboundOrderHeader;
